module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-Front_1.43948298.jpg";